import { render, staticRenderFns } from "./CaChipsbar.vue?vue&type=template&id=58429946"
import script from "./CaChipsbar.vue?vue&type=script&lang=js"
export * from "./CaChipsbar.vue?vue&type=script&lang=js"
import style0 from "./CaChipsbar.vue?vue&type=style&index=0&id=58429946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports